import { NavigationWorkspaceItemWithThemes } from 'front-end/src/components/navigation/NavigationWorkspaceItemWithThemes'
import { NavigationWorkspaceItem } from 'front-end/src/components/navigation/NavigationWorkspaceItem'
import { Box } from 'front-end/src/components'
import React from 'react'

export const WorkspaceAccordionItem = ({ workspace, hideNavigation }) => (
  <Box mb="4px">
    {workspace.themes.filter((theme) => theme.topicsCount > 0).length > 0 ? (
      <NavigationWorkspaceItemWithThemes
        workspace={workspace}
        hideNavigation={hideNavigation}
      />
    ) : (
      <NavigationWorkspaceItem
        workspace={workspace}
        hideNavigation={hideNavigation}
      />
    )}
  </Box>
)
